import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "../../Localization.jsx"

import HeatmapPage from "../../pages/HeatmapPage.jsx"

import {
  Icon,
  Button,
} from '@material-ui/core';

class HeatmapBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  render() {
    return (
      <div ref="div" style={{padding:"10px 0 10px 10px"}}>
        <Switch condition={this.props.parent.state.status}>
          <Case value={HeatmapPage.DATE_VIEW_BY_LOCALE()}>
            <Button
              color="secondary"
              onClick={this.props.root.goBackHistory}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.BACK}
            </Button>
            {/* <Button
              color="primary"
              onClick={this.props.parent.exportAnswer}
            >
              <Icon className="buttonIconLeft">save_alt</Icon>
              {Localization.strings.EXPORT_ANSWER}
            </Button> */}
          </Case>
          <Case value={HeatmapPage.SESSION_VIEW_BY_DATE()}>
            <Button
              color="secondary"
              onClick={this.props.root.goBackHistory}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.DATE_LIST}
            </Button>
            {/* <Button
              color="primary"
              onClick={this.props.parent.exportAnswer}
            >
              <Icon className="buttonIconLeft">save_alt</Icon>
              {Localization.strings.EXPORT_ANSWER}
            </Button> */}
          </Case>
          <Case value={HeatmapPage.HEATMAP_VIEW_BY_SESSION_ID()}>
            <Button
              color="secondary"
              onClick={this.props.root.goBackHistory}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.SESSION_LIST}
            </Button>
          </Case>
          {/* <Case value={HeatmapPage.RET_VIEW_SUBMISSION_HISTORY()}>
            history
          </Case> */}
        </Switch>
      </div>
    )
  }
}

export default HeatmapBar;
